'use client';
import CustomScrollBar from '../component/CustomScrollBar';
import { useRef } from 'react';
import { MeetingMsgItem } from '../type';
import { useLocale } from 'use-intl';
import { getCMSIntlVal } from '../utils/common';
import Image from '../../../image';

const MessageInfoItem = ({ item }: { item: MeetingMsgItem }) => {
  const { link, imgUrl } = item || {};

  const locale = useLocale();
  const title = getCMSIntlVal(item, 'title', locale);
  return (
    <div
      className="p-5 h-[248px] bg-[#E1EDFF] w-60 flex-shrink-0 text-[#121C59] flex flex-col justify-between"
      onClick={() => window.open(link, '_blank')}
    >
      <h5 className="text-base font-400 line-clamp-3">{title}</h5>
      <Image
        src={imgUrl}
        className="w-[200px] h-[112px]"
        loading="lazy"
        width={200}
        height={112}
        alt={'Message Image'}
      />
    </div>
  );
};

const MessageInfoMobile = ({
  list = [],
  className,
}: {
  list: MeetingMsgItem[];
  className: string;
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  return (
    <div className={`w-full ${className}`}>
      <div
        className="flex flex-nowrap gap-3 overflow-x-auto scrollbar-hidden mobile:px-5"
        ref={scrollRef}
      >
        {list.map((item) => (
          <MessageInfoItem item={item} key={item.id}></MessageInfoItem>
        ))}
      </div>
      <CustomScrollBar scrollRef={scrollRef}></CustomScrollBar>
    </div>
  );
};

export default MessageInfoMobile;
